import { render, staticRenderFns } from "./ReportingComparisonAggregate.vue?vue&type=template&id=460854a8&scoped=true&"
import script from "./ReportingComparisonAggregate.vue?vue&type=script&lang=js&"
export * from "./ReportingComparisonAggregate.vue?vue&type=script&lang=js&"
import style0 from "./ReportingComparisonAggregate.vue?vue&type=style&index=0&id=460854a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460854a8",
  null
  
)

export default component.exports